import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';
import ProfileLayout, { PROFILE_TEXTS } from './ProfileLayout';

const SERVER = process.env.REACT_APP_SERVER_URL || '';

const ProfileHome = ({ locale }) => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const t = PROFILE_TEXTS[locale] || PROFILE_TEXTS['en-EU'];
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axiosInstance.get(endpoints.accountInfoMe);
        const body = data?.data ?? data;
        if (!cancelled) setAccount(body);
      } catch {
        if (!cancelled) setAccount(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const fullName = [account?.FirstName, account?.LastName].filter(Boolean).join(' ').trim();
  const profileImg = account?.ProfileImage;
  const avatarUrl =
    profileImg?.url != null
      ? String(profileImg.url).startsWith('http')
        ? profileImg.url
        : `${SERVER}${profileImg.url}`
      : null;

  const handlePrizesClick = () => history.push(`${path}/prizes`);

  return (
    <ProfileLayout locale={locale}>
      {loading ? (
        <Box display="flex" justifyContent="center" py={3}>
          <CircularProgress style={{ color: '#fff' }} />
        </Box>
      ) : (
        <>
          <Box display="flex" alignItems="center" style={{ gap: 16 }}>
            <Avatar src={avatarUrl || undefined} style={{ width: 72, height: 72 }}>
              {(fullName || '?').slice(0, 1).toUpperCase()}
            </Avatar>
            <Box>
              <Typography variant="h6" style={{ color: '#fff' }}>
                {fullName || '—'}
              </Typography>
            </Box>
          </Box>
          <Button
            fullWidth
            variant="contained"
            onClick={handlePrizesClick}
            style={{
              marginTop: 24,
              backgroundColor: '#4CC10C',
              backgroundImage: 'linear-gradient(135deg, #4CC10C 0%, #1F6D0A 100%)',
              color: '#fff',
              borderRadius: 28,
              textTransform: 'none',
              padding: '12px 24px',
            }}
          >
            {t.prizes}
          </Button>
        </>
      )}
    </ProfileLayout>
  );
};

ProfileHome.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default ProfileHome;
